/**
 * API 错误上报：整理请求/响应详情（脱敏 + 体积限制，便于排查）
 * 对齐移动端 utils/error-report/apiReportPayload.js
 */

const SENSITIVE_KEY_RE =
  /^(password|passwd|pwd|old_password|new_password|token|access_token|refresh_token|authorization|secret|sms_code|verify_code|pay_sign|paysig|signature|sign_data)$/i

const MAX_STRING = 8000
const MAX_DEPTH = 6
const MAX_ARRAY = 40
const MAX_KEYS = 80

function truncateString (s) {
  const str = String(s)
  if (str.length <= MAX_STRING) return str
  return `${str.slice(0, MAX_STRING)}…[truncated len=${str.length}]`
}

export function sanitizeForErrorReport (input, depth = 0) {
  if (input == null) return input
  if (typeof input === 'string') return truncateString(input)
  if (typeof input === 'number' || typeof input === 'boolean') return input
  if (typeof input !== 'object') return truncateString(input)
  if (depth >= MAX_DEPTH) return '[MaxDepth]'

  if (Array.isArray(input)) {
    const mapped = input.slice(0, MAX_ARRAY).map((item) => sanitizeForErrorReport(item, depth + 1))
    if (input.length > MAX_ARRAY) {
      mapped.push(`…[+${input.length - MAX_ARRAY} items]`)
    }
    return mapped
  }

  const out = {}
  let n = 0
  try {
    for (const key of Object.keys(input)) {
      if (n++ >= MAX_KEYS) {
        out.__truncatedKeys__ = true
        break
      }
      if (SENSITIVE_KEY_RE.test(key)) {
        out[key] = '[REDACTED]'
        continue
      }
      try {
        out[key] = sanitizeForErrorReport(input[key], depth + 1)
      } catch (e) {
        out[key] = '[Unserializable]'
      }
    }
  } catch (e) {
    return truncateString(input)
  }
  return out
}

function pickSafeHeaders (headers) {
  if (!headers || typeof headers !== 'object') return undefined
  const out = {}
  for (const key of Object.keys(headers)) {
    if (/authorization|token|cookie/i.test(key)) {
      out[key] = '[REDACTED]'
    } else {
      out[key] = sanitizeForErrorReport(headers[key], 0)
    }
  }
  return out
}

export function buildApiErrorAdditional (config = {}, extras = {}) {
  const cfg = config || {}
  const headers = cfg.header || cfg.headers
  return {
    url: extras.url || cfg.url || '',
    method: String(extras.method || cfg.method || '').toLowerCase() || undefined,
    statusCode: extras.statusCode,
    businessCode: extras.businessCode,
    requestData: sanitizeForErrorReport(cfg.data),
    requestParams: sanitizeForErrorReport(cfg.params),
    responseData: sanitizeForErrorReport(extras.responseData),
    requestHeaders: pickSafeHeaders(headers),
    timeout: cfg.timeout,
  }
}
